import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';

export default class UnitPerformanceDetail extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            unitData: [],
            yearData: [],
            fromWeekData: [],
            toWeekData: [],
            selectedYear: 0,
            selectedFromWeek: 0,
            selectedToWeek: 0,
            unitGraphData: {
                labels: [],
                currYTDSales: [],
                prevYTDSales: []
            },
            tableHidden: true
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleFromSelectChange = this.handleFromSelectChange.bind(this);
        this.handleToSelectChange = this.handleToSelectChange.bind(this);
        this.getUnitPerformanceDetail = this.getUnitPerformanceDetail.bind(this);
    }

    async loadWeeksForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getweeksforyear?yearId=' + year, 200);
        let fromWeeksData = [];
        let toWeeksData = [];
        result.data.forEach((week) => fromWeeksData.push({ checked: false, value: week.value, text: week.label }));
        result.data.forEach((week) => toWeeksData.push({ checked: false, value: week.value, text: week.label }));

        fromWeeksData[0].checked = true;
        toWeeksData[0].checked = true;
        this.setState({
            fromWeekData: fromWeeksData,
            toWeekData: toWeeksData,
            selectedFromWeek: fromWeeksData[0].value,
            selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadWeeksForYear(selected[0])
    }

    handleFromSelectChange(selected) {
        this.setState({
            selectedFromWeek: selected[0]
        });
    }

    handleToSelectChange(selected) {
        this.setState({
            selectedToWeek: selected[0]
        });
    }

    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        let unitGraphData = {
            labels: [],
            currYTDSales: [],
            prevYTDSales: []
        }
        let graphResponse = await dl.Post('/common/GetGraphData', 2)

        graphResponse.data.forEach((entry) => {
            unitGraphData.labels.push(entry.month);
            unitGraphData.currYTDSales.push(entry.currYr);
            unitGraphData.prevYTDSales.push(entry.prevYr);
        })

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value,
            unitGraphData: unitGraphData
        })
        this.props.loaderOff();
    }

    async getUnitPerformanceDetail() {
        this.props.loaderOn();
        var dl = new DataLayer();
        await dl.Get('/manager/GetUnitPerformanceDetailed?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek, 200).then((response) => {
            let demRecs = [];
            let rec;
            
            response.data.map((dem) => {
                let telNo = "tel:" + dem.smsQueryCell;
                rec = {
                    Status: dem.statusCode1 +''+ dem.statusCode2,
                    SFCurrentCode: dem.sfCurrentCode,
                    Surname: dem.surname, 
                    FirstNames: dem.firstNames,
                    SMSQueryCell: [<a href={telNo}>{dem.smsQueryCell}</a>],
                    SFStartWeekId: dem.sfStartWeekId, 
                    SFEndWeekId: dem.sfEndWeekId,
                    Recognition: this.formatter.formatCurrency(dem.recognition),
                    Leads: dem.leads,
                    ActiveCount: dem.activeCount,
                    QualifiedCount: dem.qualifiedCount
                }
                demRecs.push(rec);
            });
            let tableData = {
                columns: [{
                    label: 'Status',
                    field: 'Status',
                    sort: 'asc'
                },
                {
                    label: 'Dem Code',
                    field: 'SFCurrentCode',
                    sort: 'asc'
                },
                {
                    label: 'Name',
                    field: 'firstNames',
                    sort: 'asc'
                },
                {
                    label: 'Surname',
                    field: 'Surname',
                    sort: 'asc'
                },
                {
                    label: 'Mobile No',
                    field: 'SMSQueryCell',
                    sort: 'asc'
                },
                {
                    label: 'Start Week',
                    field: 'SFStartWeekId',
                    sort: 'asc'
                },
                {
                    label: 'End Week',
                    field: 'SFEndWeekId',
                    sort: 'asc'
                },
                {
                    label: 'Sales',
                    field: 'Recognition',
                    sort: 'asc'
                },
                {
                    label: 'Leads',
                    field: 'Leads',
                    sort: 'asc'
                },
                {
                    label: 'Active',
                    field: 'active',
                    sort: 'asc'
                }, {
                    label: 'Qualified',
                    field: 'qualified',
                    sort: 'asc'
                }],
                rows: demRecs
            }
            this.setState({
                unitData: tableData,
                tableHidden: false
            });
            this.props.loaderOff();
        })

    }

    render() {

        return (
            <div>
                <Header headerText='Unit Performance (Detailed)'
                    subHeaderText="(Click Go to load detailed report for selected weeks)"
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                <MDBRow>
                    <MDBCol md="6">
                        <MDBContainer>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="Year..."
                                        options={this.state.yearData}
                                        selected="Filter"
                                        getValue={this.handleYearSelectChange}
                                        required
                                    />
                                </MDBCol>

                            </MDBRow>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="From Week..."
                                        options={this.state.fromWeekData}
                                        selected="Filter"
                                        getValue={this.handleFromSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="To Week..."
                                        options={this.state.toWeekData}
                                        selected="Filter"
                                        getValue={this.handleToSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol>
                                    <MDBBtn onClick={this.getUnitPerformanceDetail}>Go</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </MDBCol>

                    <MDBCol md="6">
                        <MDBContainer>
                            <DashboardLineGraph chartName="Unit Sales Performance" graphData={this.state.unitGraphData} />
                        </MDBContainer>
                    </MDBCol>
                </MDBRow>

                <br />

                <div hidden={this.state.tableHidden}>
                    <hr />
                    <MDBContainer>
                        <MDBRow>
                            <span style={{ fontWeight: "bold" }}>Detailed Unit Results<br />Weeks {this.state.selectedFromWeek} to {this.state.selectedToWeek}</span>
                        </MDBRow>

                    </MDBContainer>
                    <MDBDataTable
                        responsive
                        striped
                        bordered
                        hover
                        data={this.state.unitData}
                        paging={false}
                        autoWidth
                    />;

                        </div>
                    </MDBCardBody>
                    </MDBCard>
            </div>
        );
    }


}
